var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 262.624,
    y1: 547.206,
    x2: 375.377,
    y2: 432.484,
    id: "A",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#070135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612d50"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.249635 0 0 .249239 -63.665715 -106.04659)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.016,
    height: 128.546,
    ry: 20.68,
    x: 255.239,
    y: 425.326,
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.213 480.665c3.27 0 5.748-.7 7.437-2.133s2.533-3.52 2.533-6.293c0-2.738-.844-4.818-2.533-6.24-1.7-1.458-4.168-2.187-7.437-2.187h-11.48v16.854h11.48m.7 34.827c4.167 0 7.293-.87 9.377-2.613 2.12-1.742 3.18-4.373 3.18-7.893 0-3.45-1.042-6.027-3.126-7.733-2.084-1.742-5.227-2.613-9.43-2.613h-12.18v20.854h12.18m19.293-28.64c4.455 1.28 7.904 3.645 10.347 7.093s3.664 7.68 3.665 12.694c0 7.68-2.623 13.405-7.868 17.174s-13.22 5.653-23.927 5.653h-34.436V449.84h31.15c11.173 0 19.257 1.67 24.25 5.013 5.03 3.342 7.545 8.694 7.545 16.054 0 3.876-.916 7.182-2.748 9.92-1.832 2.702-4.5 4.7-7.976 6.027",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.5d590f6c245312fdf16a7e8ab1d6ba44.svg";
export { ForwardRef as ReactComponent };